/* eslint-disable react/require-default-props */

import React, { PropsWithChildren, useRef } from "react";
import styled from "styled-components";

interface Props extends PropsWithChildren {
	dimmer?: boolean | string;
	zIndex: number;
	onDimmerClick?: () => void;
}

const StyledDimmer = styled.div<Props>`
	background-color: ${(props) =>
		props.dimmer === true
			? `rgba(0, 0, 0, .5)`
			: props.dimmer || "transparent"};
	position: absolute;
	width: 100%;
	height: 100%;
	z-index: ${(props) => props.zIndex};
	display: flex;
	justify-content: center;
	align-items: center;
`;
const Dimmer: React.FC<Props> = ({
	dimmer,
	zIndex,
	children,
	onDimmerClick,
}) => {
	const ref = useRef<HTMLDivElement | null>(null);

	const handleBackdropClick = (event: React.MouseEvent<HTMLDivElement>) => {
		if (event.target !== event.currentTarget) return;
		onDimmerClick?.();
	};

	return (
		<StyledDimmer
			ref={ref}
			dimmer={dimmer}
			zIndex={zIndex}
			onClick={onDimmerClick ? handleBackdropClick : undefined}
			role={onDimmerClick ? "presentation" : undefined}
		>
			{children}
		</StyledDimmer>
	);
};

export default Dimmer;
